module.exports = __webpack_public_path__ + "assets/webgl/ticket_recto_EN_L0.85fa25e5.jpg";